import {
  Banner,
  useApi,
  useTranslate,
  reactExtension, TextBlock,
  BlockStack, useSettings, InlineStack, Image, Heading, Grid, GridItem,
  useCartLines
} from '@shopify/ui-extensions-react/checkout';
import {useEffect, useState} from "react";

export default reactExtension(
  'purchase.checkout.block.render',
  () => <Extension/>,
);

function Extension() {
  const translate = useTranslate();
  const {extension, cost, buyerIdentity} = useApi();
  const cartLines = useCartLines();

  const [category, setCategory] = useState('normal');

  const {
    image_1, title_1, content_1, category_1,
    image_1_1, title_1_1, content_1_1, category_1_1,
    image_2, title_2, content_2, category_2,
    image_3, title_3, content_3, category_3,
    image_4, title_4, content_4, category_4
  } = useSettings();

  useEffect(() => {
    cartLines.forEach((item) => {
      if (item.merchandise.title.indexOf('Custom ') !== -1) {
        setCategory('custom');
      }
    })

  }, []);

  return (
    <BlockStack>
      {(category == 'normal') ? <Grid columns={[50, 'fill']}
                                      rows={['auto']}
                                      spacing="tight">
        <Image source={image_1 as string}></Image>
        <BlockStack>
          <Heading>{title_1}</Heading>
          <TextBlock inlineAlignment={'start'}>
            {content_1}
          </TextBlock>
        </BlockStack>
      </Grid> : <Grid columns={[50, 'fill']}
                      rows={['auto']}
                      spacing="tight">
        <Image source={image_1_1 as string}></Image>
        <BlockStack>
          <Heading>{title_1_1}</Heading>
          <TextBlock inlineAlignment={'start'}>
            {content_1_1}
          </TextBlock>
        </BlockStack>
      </Grid>}

      {(title_2 ?
        <Grid columns={[50, 'fill']}
              rows={['auto']}
              spacing="tight">
          <Image source={image_2 as string}></Image>
          <BlockStack>
            <Heading>{title_2}</Heading>
            <TextBlock inlineAlignment={'start'}>
              {content_2}
            </TextBlock>
          </BlockStack>
        </Grid> : '')}
      {(title_3 ?
        <Grid columns={[50, 'fill']}
              rows={['auto']}
              spacing="tight">
          <Image source={image_3 as string}></Image>
          <BlockStack>
            <Heading>{title_3}</Heading>
            <TextBlock inlineAlignment={'start'}>
              {content_3}
            </TextBlock>
          </BlockStack>
        </Grid> : '')}
      {(title_4 ?
        <Grid columns={[50, 'fill']}
              rows={['auto']}
              spacing="tight">
          <Image source={image_4 as string}></Image>
          <BlockStack>
            <Heading>{title_4}</Heading>
            <TextBlock inlineAlignment={'start'}>
              {content_4}
            </TextBlock>
          </BlockStack>
        </Grid> : '')}
    </BlockStack>
  );
}
